import React, { useEffect } from 'react'
import styled from 'styled-components'
import AOS from 'aos'
import 'aos/dist/aos.css'

const Services = () => {
    useEffect(() => {
        AOS.init()
      },[])
  return (
    <ServicesSection id="ServiceSection" >
      <ServicesTitle  >Service</ServicesTitle>
      <ServicesContainer data-aos="fade-right" data-aos-duration='750' data-aos-delay='0' >
        <ServicesContentContainer> <ServiceHeading>Gas carburizing</ServiceHeading> is a specialized heat treatment process that enhances the surface hardness and wear resistance of steel components. By introducing carbon into the material through a controlled atmosphere, we ensure superior durability and performance in your components.</ServicesContentContainer>
        <ServicesContentContainer> <ServiceHeading>Annealing process</ServiceHeading> involves heating and controlled cooling to improve the ductility and machinability of metals. It reduces internal stresses, refines grain structure, and enhances material properties, making components more versatile and easy to work with.</ServicesContentContainer>
        <ServicesContentContainer> <ServiceHeading>Hardening</ServiceHeading> is the art of transforming materials into robust and resilient forms. We elevate the hardness of your metal components, ensuring they withstand extreme conditions and deliver superior strength, durability, and resistance to wear.</ServicesContentContainer>
        <ServicesContentContainer> <ServiceHeading>Normalizing</ServiceHeading> refines the microstructure of metals, improving their mechanical properties and overall performance. By eliminating inconsistencies and enhancing uniformity, we ensure your components meet and exceed industry standards for quality and reliability.</ServicesContentContainer>
        <ServicesContentContainer> <ServiceHeading>Stress relieving</ServiceHeading> is essential for mitigating internal stresses in metal components. Our process helps prevent deformation, cracking, or fatigue, ensuring your parts remain stable, reliable, and ready to excel in their intended applications.</ServicesContentContainer>
        <ServicesContentContainer> <ServiceHeading>Tempering</ServiceHeading> complements hardening by optimizing the balance between hardness and toughness in metal components. Through precise temperature control, we enhance your components' mechanical properties, ensuring they perform reliably in demanding applications.</ServicesContentContainer>
      </ServicesContainer>
    </ServicesSection>
  )
}

export default Services


const ServicesSection = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 2.5rem;
  position: relative;

  @media(max-width: 1280px){
      margin-top: 2.5rem;
  }

  @media(max-width: 900px){
      flex-direction: column;
      align-items: flex-end;
      margin-top: 0rem;
  }

  

`

const ServicesTitle = styled.h1`
  transform: rotate(90deg);
  color: #F2B705;
  font-family: var(--font-primary);
  font-size: 6rem;
  font-weight: 600;
  white-space: nowrap; 
  padding: 0.5rem;
  margin-top: 10.5rem;
  flex-shrink: 0;

  @media(max-width: 1280px){
      font-size: 4.8rem;
  }

  @media(max-width: 900px){
    transform: rotate(0deg);
    font-size: 6rem;


  }
`

const ServicesContainer = styled.div`
  width: 100%;

  background: #fff;

  padding: 5rem;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 5rem;

  @media(max-width: 1080px){
      grid-template-columns: repeat(2, 1fr);
  }

  @media(max-width: 640px){
      grid-template-columns: repeat(1, 1fr);
  }

`


const ServicesContentContainer = styled.div`
  color: #000;
  font-family: var(--font-secondary);
  font-size: 1.4rem;
  font-weight: 300;
`


const ServiceHeading = styled.span`
  font-size: 1.8rem;
  position: relative;
  cursor: pointer;
  font-weight: 400;

  &::before {
  content: '';
  background-color: hsl(45, 96%, 48%, 0.5);
  position: absolute;
  left: 0;
  bottom: 3px;
  width: 100%;
  height: 8px;
  z-index: -1;
  transition: all .3s ease-in-out;
  }

  &:hover::before {
  bottom: 0;
  height: 100%;
  }
`